<template>
  <div class="RangePins">
    <div class="RangePins-item" v-for="pin in pins" :key="pin.year">
      <div class="RangePins-media">
        <img v-if="imgSrc(pin.year)" :src="imgSrc(pin.year)" />
      </div>
      <div class="RangePins-info">
        <h3 class="Range-title">
          {{ pin.year }}
        </h3>
        <div class="Range-description">
          {{ pin.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as images from "@/data/historyImages";

export default {
  props: {
    pins: {
      type: Array,
      required: true,
    },
  },
  methods: {
    imgSrc(year) {
      return images.pins[year];
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './RangePins.styl';
</style>
